// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChannelForm__form-a0993a {
  flex: 1;
  overflow: auto;
}

.ChannelForm__fields-ccfa6e {
  padding: 24px 24px 0 24px;
}

.ChannelForm__gap-d932a2 {
  margin-bottom: 16px;
}

.ChannelForm__radio-gap-bdf1c6 {
  margin-top: 0;
  margin-bottom: 24px;
  padding: 0;
}

.ChannelForm__hide-ab9287 {
  display: none;
}

.ChannelForm__section-indent-c592da {
  margin-bottom: 32px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/components/ChannelForm/ChannelForm.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,cAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,UAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,mBAAA;AACF","sourcesContent":[".form {\n  flex: 1;\n  overflow: auto;\n}\n\n.fields {\n  padding: 24px 24px 0 24px;\n}\n\n.gap {\n  margin-bottom: 16px;\n}\n\n.radio-gap {\n  margin-top: 0;\n  margin-bottom: 24px;\n  padding: 0;\n}\n\n.hide {\n  display: none;\n}\n\n.section-indent {\n  margin-bottom: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `ChannelForm__form-a0993a`,
	"fields": `ChannelForm__fields-ccfa6e`,
	"gap": `ChannelForm__gap-d932a2`,
	"radio-gap": `ChannelForm__radio-gap-bdf1c6`,
	"radioGap": `ChannelForm__radio-gap-bdf1c6`,
	"hide": `ChannelForm__hide-ab9287`,
	"section-indent": `ChannelForm__section-indent-c592da`,
	"sectionIndent": `ChannelForm__section-indent-c592da`
};
module.exports = ___CSS_LOADER_EXPORT___;
